/**
 * Identity for the first-party "Atlas Coding Agent" system bot. Mirrors
 * `bot_id::ATLAS_CODER_BOT_ID` on the backend. Deliberately a distinct bot
 * from Atlas (see `macroAgent.ts`): mentioning Atlas answers in chat, while
 * mentioning Atlas Coding Agent opens a sandboxed coding-agent session.
 */
export const ATLAS_CODER_BOT_ID = '00000000-0000-0000-0000-00000000a9e7';

/**
 * Canonical principal id for Atlas Coding Agent, matching the `bot|<uuid>` form used
 * for bot senders and participants everywhere else.
 */
export const ATLAS_CODER_PRINCIPAL_ID = `bot|${ATLAS_CODER_BOT_ID}`;

/** Display name for Atlas Coding Agent. */
export const ATLAS_CODER_NAME = 'Atlas Coding Agent';

/** Handle used to find Atlas Coding Agent in the mention typeahead (`@coder`). */
export const ATLAS_CODER_HANDLE = 'coder';

/**
 * Whether an id refers to the Atlas Coding Agent bot. Accepts both the bare UUID and
 * the `bot|<uuid>` participant/sender form.
 */
export function isAtlasCoderId(id: string | undefined): boolean {
  if (!id) return false;
  const bare = id.startsWith('bot|') ? id.slice('bot|'.length) : id;
  return bare === ATLAS_CODER_BOT_ID;
}
